import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { shopifyService } from '../../../services/shopifyService';
import { toast } from '../../../hooks/use-toast';

export const ShopifyCallback: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const shop = params.get('shop');
        const state = params.get('state'); // Este é o companyId que passámos

        if (!code || !shop || !state) {
          throw new Error('Parâmetros em falta na URL de callback');
        }

        await shopifyService.exchangeCodeForToken(code, shop, state);
        
        toast.success('Loja Shopify conectada com sucesso!');
        navigate('/dashboard/integrations/settings');
      } catch (error) {
        console.error('Erro no callback do Shopify:', error);
        toast.error('Erro ao conectar loja Shopify');
        navigate('/dashboard/integrations/settings');
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div className="p-8 text-center">
      <h1 className="text-2xl font-bold mb-4">A conectar à sua loja Shopify...</h1>
      <p className="text-gray-600">Por favor, aguarde enquanto processamos a autorização.</p>
    </div>
  );
};
